export default "__VITE_ASSET__RCh4hZpT__"